import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LanguageService, TranslationItem } from '@hazmatsuite-next/ui';
import { map, take } from 'rxjs';
import { EditAddressModel } from '../../models/edit-address.model';
import { AddressService } from '../../services/address.service';

@Component({
  selector: 'hazmatsuite-next-address-editor',
  templateUrl: './address-editor.component.html',
  styleUrls: ['./address-editor.component.scss'],
})
export class AddressEditorComponent implements OnInit {
  @Input() item: EditAddressModel | null = null;
  @Input() countries: TranslationItem[] = [];
  @Output() editCallback = new EventEmitter();

  form: FormGroup;

  addressEditorTranslations$ = this.languageService.translations$.pipe(map(data => data['AddressEditorResource']));
  validationTranslations$ = this.languageService.translations$.pipe(map(data => data['ValidationResource']));
  generalInformationTranslation$ = this.languageService.translations$.pipe(map(data => data['GeneralInformationResource']));

  constructor(private fb: FormBuilder, private languageService: LanguageService, private addressServcie: AddressService) {
    this.form = this.fb.group({
      companyName: ['', Validators.required],
      companyAddon: [''],
      addressLine1: ['', Validators.required],
      addressLine2: [''],
      addressLine3: [''],
      zipCode: ['', Validators.required],
      place: ['', Validators.required],
      country: ['', Validators.required],
    })
  }

  ngOnInit(): void {
    if (this.item) {
      this.companyName?.setValue(this.item.CompanyName);
      this.companyAddon?.setValue(this.item.CompanyAddon);
      this.addressLine1?.setValue(this.item.AddressLine1);
      this.addressLine2?.setValue(this.item.AddressLine2);
      this.addressLine3?.setValue(this.item.AddressLine3);
      this.zipCode?.setValue(this.item.ZipCode);
      this.place?.setValue(this.item.Place);
      this.country?.setValue(this.item.Country);
    }
  }

  cancel(): void {
    this.editCallback.emit();
  }

  save(): void {
    if (this.form.valid) {
      const model: EditAddressModel = {
        CompanyName: this.companyName?.value,
        CompanyAddon: this.companyAddon?.value,
        AddressLine1: this.addressLine1?.value,
        AddressLine2: this.addressLine2?.value,
        AddressLine3: this.addressLine3?.value,
        ZipCode: this.zipCode?.value,
        Place: this.place?.value,
        Country: this.country?.value,
        ID: this.item?.ID ?? 0,
        Title: ''
      };
      this.addressServcie.saveAddress(this.item != null, model).pipe(
        take(1)
      ).subscribe(() => this.editCallback.emit());
    } else {
      this.form.markAllAsTouched();
    }
  }

  get companyName(): AbstractControl | null {
    return this.form.get('companyName');
  }

  get companyAddon(): AbstractControl | null {
    return this.form.get('companyAddon');
  }

  get addressLine1(): AbstractControl | null {
    return this.form.get('addressLine1');
  }

  get addressLine2(): AbstractControl | null {
    return this.form.get('addressLine2');
  }

  get addressLine3(): AbstractControl | null {
    return this.form.get('addressLine3');
  }

  get zipCode(): AbstractControl | null {
    return this.form.get('zipCode');
  }

  get place(): AbstractControl | null {
    return this.form.get('place');
  }

  get country(): AbstractControl | null {
    return this.form.get('country');
  }
}
